import FeatherIcon from "feather-icons-react";
import React, { FC, useState } from "react";
import { useTranslation } from "react-i18next";

import { Button } from "@components/base";
import { AssetQuestionnaireModal } from "@components/main/csob/hub";
import { useUserStore } from "@store/user";
import { useCreateCsobForm } from "@api";

const AddAssetButton: FC = () => {
  const { t } = useTranslation();
  const { user } = useUserStore();
  const [assetQuestionnaireModalOpen, setAssetQuestionnaireModalOpen] =
    useState<boolean>(false);
  const { createCsobFormEnabled } = useCreateCsobForm(user);

  const openAssetQuestionnaireModal = (): void =>
    setAssetQuestionnaireModalOpen(true);
  const closeAssetQuestionnaireModal = (): void =>
    setAssetQuestionnaireModalOpen(false);

  return (
    createCsobFormEnabled && (
      <>
        <Button
          variant="text"
          onClick={openAssetQuestionnaireModal}
          size="small"
          startIcon={<FeatherIcon icon="plus" />}
        >
          {t("csob.questionnaires.addNewAsset")}
        </Button>
        <AssetQuestionnaireModal
          isOpen={assetQuestionnaireModalOpen}
          onClose={closeAssetQuestionnaireModal}
        />
      </>
    )
  );
};

export default AddAssetButton;
